import styled from 'styled-components';
import { TabsMixin } from '../../mixins/components/TabsMixin';
export var StyledTabs = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledTabs",
  componentId: "c11n-8-111-1__sc-shmpg5-0"
})(["", ""], TabsMixin);